/*eslint jsx-a11y/anchor-is-valid: "off"*/
/*eslint jsx-a11y/click-events-have-key-events: "off"*/
/*eslint jsx-a11y/no-static-element-interactions: "off"*/
import './navigation-bar.css';

import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';

import propertiesService from '../service/properties-service';
import { usePageDynamicResults } from '../hooks/use-page-dynamic';

import getSlug from '../service/slug-service';

import siteData from '../data/site-data.yaml';

import logo from '../images/logo/intrepid.webp';

const NavigationBar = () => {
  const data = usePageDynamicResults();

  const pageSort = (a, b) => {
    const propsA = propertiesService.getProperties(a);
    const propsB = propertiesService.getProperties(b);

    const sortProp = 'Header Position';

    return parseInt(propsA[sortProp]) - parseInt(propsB[sortProp]);
  };

  const itemLimit = 7;

  return (
    <header className="navigation-bar-container">
      <Navbar collapseOnSelect expand="sm">
        <Navbar.Brand href="/">
          <img alt="Intrepid" src={logo} width="107" height="40" className="header-logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav>
            {propertiesService
              .getPagesWithLabels(data, ['header-menu'])
              .sort(pageSort)
              .map((edge) => {
                // check if a name override exists
                const labels = propertiesService.getLabels(edge);
                const children = propertiesService.getChildren(data, edge).sort(propertiesService.sortResults(labels));
                const props = propertiesService.getProperties(edge);
                const title = props['External Name']
                  ? props['External Name']
                  : edge.node.title;

                if (children.length === 0 || labels.includes('header-menu-no-children')) {
                  return (
                    <Nav.Link key={edge.node.slug} href={'/' + edge.node.slug} className="header-menu-item-left">
                      {title}
                    </Nav.Link>
                  );
                } else {
                  return (
                    <NavDropdown
                      key={edge.node.slug}
                      id={edge.node.slug}
                      title={title}
                      className="header-menu-item-dropdown"
                    >
                      <NavDropdown.Item
                        key={edge.node.slug}
                        href={'/' + edge.node.slug}
                        className="header-menu-item-dropdown"
                      >
                        Home
                      </NavDropdown.Item>
                      <NavDropdown.Divider />
                      {children.slice(0, itemLimit - 1).map((childPage) => {
                        const slug = getSlug(childPage.node.title);
                        const childProps = propertiesService.getProperties(childPage);
                        const childTitle = childProps['External Name']
                          ? childProps['External Name']
                          : childPage.node.title;

                        return (
                          <NavDropdown.Item key={slug} className="header-menu-item-dropdown" href={'/' + slug}>
                            {childTitle}
                          </NavDropdown.Item>
                        );
                      })}
                    </NavDropdown>
                  );
                }
              })}
          </Nav>
        </Navbar.Collapse>

        <Nav.Link key="get-in-touch" href="/get-in-touch" className="header-menu-item-right">
          Get in touch
        </Nav.Link>
      </Navbar>
    </header>
  );
};

export default NavigationBar;
